module.exports = __webpack_public_path__ + "img/swiper.5c77f704.png";